import { Browser } from '@capacitor/browser';
import { TIENDA_NUBE_THEMES_LINKS } from 'commons/constants';
import { useTranslationLanguage } from 'commons/hooks';
import { openWindow } from 'commons/utils/window';
import { useIsMobileDevice } from 'domains/Auth/hooks';

export function useInstallDraft(themeCode: string, themeVariant?: string) {
  const isMobileDevice = useIsMobileDevice();
  const language = useTranslationLanguage();

  const installThemeInStoreUrl = `${
    TIENDA_NUBE_THEMES_LINKS[language]
  }/instalar/${themeCode}${themeVariant ? '/' + themeVariant : ''}`;

  const handleInstallDraft = async () => {
    if (isMobileDevice) {
      await Browser.open({ url: installThemeInStoreUrl });
    } else {
      openWindow(installThemeInStoreUrl, false);
    }
  };

  return handleInstallDraft;
}
